import {NgModule} from "@angular/core";
import {BrowserModule} from "@angular/platform-browser";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {HttpHelpersModule} from "../http/http-helpers.module";
import {BootstrapModalModule} from "../bootstrap-modal/bootstrap-modal.module";
import {ContactService} from "./contact.service";
import {ModifyContactDialogComponent} from "./modify-contact-dialog.component";
import {ErrorModule} from "../errors/error.module";
import {AppSettingsModule} from "../app-settings/app-settings.module";

@NgModule({
  providers: [
    ContactService,
  ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpHelpersModule,
    BootstrapModalModule,
    AppSettingsModule,
    ErrorModule,
  ],
  declarations: [
    ModifyContactDialogComponent,
  ],
  exports: [
  ],
  entryComponents: [
    ModifyContactDialogComponent,
  ],
})

export class ContactModule {
}
